try {
  class FeaturedPromo extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll("[role='tab']");
      this.tabpanels = this.querySelectorAll("[role='tabpanel']");
      this.images = this.querySelectorAll('.featured-promo__lifestyle');

      this.current_tab = 0;
      this.total_tabs = this.tabs.length;

      this.images.forEach((image) => {
        if (image.dataset.image == this.current_tab) {
          image.style.display = 'block';
        }
      });

      this.tabs.forEach((node) => {
        node.addEventListener('click', (e) => {
          const tabpanel = node.getAttribute('aria-controls');

          this.tabs.forEach((tab) => {
            tab.setAttribute('aria-selected', 'false');
          });

          this.tabpanels.forEach((tab) => {
            if (tab.getAttribute('id') == tabpanel || tab.getAttribute('id') == tabpanel + '-img') {
              tab.removeAttribute('aria-hidden');
            } else {
              tab.setAttribute('aria-hidden', 'true');
            }
          });

          this.images.forEach((image) => {
            if (image.getAttribute('aria-hidden') == 'true') {
              image.style.display = 'none';
            } else {
              image.style.display = 'block';
            }
          });

          this.current_tab = node.dataset.index;

          node.setAttribute('aria-selected', 'true');
        });
      });

      this.addEventListener('touchstart', this.handleTouchStart.bind(this));

      this.addEventListener('touchend', this.handleTouchEnd.bind(this));
    }

    handleTouchStart(e) {
      if (e.changedTouches) {
        this.touch_start = e.changedTouches[0].screenX;
      } else {
        this.touch_start = e.screenX;
      }
    }

    handleTouchEnd(e) {
      if (e.changedTouches) {
        this.touch_end = e.changedTouches[0].screenX;
      } else {
        this.touch_end = e.screenX;
      }

      this.handleSwipe();
    }

    handleSwipe() {
      const delta = Math.abs(this.touch_start - this.touch_end);

      if (delta < 50) {
        return;
      }

      if (this.touch_start > this.touch_end) {
        this.nextPage();
      } else {
        this.prevPage();
      }
    }

    nextPage() {
      this.current_tab++;

      if (this.current_tab >= this.total_tabs) {
        this.current_tab = 0;
      }

      this.setPage(this.current_tab);
    }

    prevPage() {
      this.current_tab--;

      if (this.current_tab < 0) {
        this.current_tab = this.total_tabs - 1;
      }

      this.setPage(this.current_tab);
    }

    setPage(index) {
      this.tabs.forEach((node) => {
        if (node.dataset.index == index) {
          node.click();
        }
      });
    }
  }

  customElements.define('featured-promo', FeaturedPromo);
} catch {}
